<!-- 会议直采特价 -->
<template>
    <div class='container'>
        <div class="main">
            <div class="mianLine">
                <p class="title">您感兴趣的资源：</p>
                <p class="p_1">法国巴黎 Mercure Hotel ****</p>
            </div>
            <div class="mainDetail" v-for="item in 2" :key="item">
                <div class="mianLine">
                    <p class="title">举办时间？</p>
                    <el-date-picker style="width: 1.5rem;margin-right: 0.1rem;" size="small" v-model="value1" type="date"
                        placeholder="选择日期">
                    </el-date-picker>
                    <el-select style="margin-right: 0.3rem;width: 1.5rem;" size="small" v-model="num" placeholder="请选择房型">
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                    <el-button size="mini" class="addBtn">添加其他入住日期</el-button>
                </div>
                <div class="mianLine">
                    <el-input size=small v-model="input" placeholder="请输入您想告诉资源方的，关于此次活动时长的特别说明或问题（如有）"></el-input>
                </div>
                <div class="mianLine">
                    <p class="title">参加人数？</p>
                    <el-radio v-model="radio" label="1">有相对准确的人数</el-radio>
                    <div v-show="radio == 1" style="margin-right: 0.2rem;">
                        <el-input size="mini" style="width: 0.7rem;" v-model="input" placeholder="请填写"></el-input> 人
                    </div>
                    <el-radio v-model="radio" label="2">大致</el-radio>
                    <el-select v-show="radio == 2" style="width: 1.2rem;" size="small" v-model="num" placeholder="请选择人数">
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="mianLine">
                    <p class="title">您想办的是一场什么活动？</p>
                    <el-select size="small" v-model="num" style="width: 3rem;" placeholder="请选择人数">
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="mianLine">
                    <p class="title">您需要的会议室</p>
                    <el-button style="margin-left: 0.2rem;" size="mini" class="addBtn">我需要不止一个会议室</el-button>
                </div>
                <div class="detail" v-for="item in 1" :key="item">
                    <div class="detailBox">
                        <div>
                            <div class="detailBoxLine">
                                <el-select style="margin-right: 0.1rem;" size="small" v-model="num" placeholder="请选择会议室">
                                    <el-option v-for="item in options" :key="item.value" :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                                <el-input style="width: 1.2rem;margin-right: 0.1rem;" size="small" v-model="num"
                                    placeholder="期望预算/间"></el-input>
                                <el-select style="margin-right: 0.1rem;width: 1.2rem;" size="small" v-model="num"
                                    placeholder="币种">
                                    <el-option v-for="item in options" :key="item.value" :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                                以内
                            </div>
                            <div class="detailBoxLine">
                                <el-input size="mini" v-model="input"
                                    placeholder="请输入您想告诉资源方的，关于所选会场的特别说明或问题（如有）"></el-input>
                            </div>
                            <div class="detailBoxLine">
                                <p class="detail_p-2">您想比较价格的会议室</p>
                                <el-select style="margin-right: 0.1rem;width: 2.5rem;" size="small" v-model="num"
                                    placeholder="请选择您相比较价格的会议室">
                                    <el-option v-for="item in options" :key="item.value" :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="rightBtnBox">
                            <div class="deleteY">
                                <i style="color: #919191;cursor: pointer;font-size: 0.2rem;" class="el-icon-delete"></i>
                            </div>
                            <el-button size="mini" class="addBtn">比较</el-button>
                        </div>
                    </div>
                </div>
                <div v-if="item != 2" class="mainDetailLine"></div>
            </div>
            <div class="mianLine">
                <p class="title">请选择您所需的设备及服务</p>
            </div>
            <div class="serviceLine" v-for="(item, keys) in siteService" :key="keys">
                <p class="serviceTitle">{{ keys }}</p>
                <p class="serviceSelect" v-for="(n, index) in item" :key="index">{{ n }}</p>
            </div>
            <el-input size="mini" v-model="input" placeholder="请输入您想告诉资源方的，关于所需设备及服务的特别说明或问题（如有）"></el-input>
        </div>
    </div>
</template>

<script>

export default {
    components: {},
    data() {
        return {
            input: '',
            value1: '',
            num: '',
            radio: '',
            options: [{
                value: '选项1',
                label: '黄金糕'
            }, {
                value: '选项2',
                label: '双皮奶'
            }, {
                value: '选项3',
                label: '蚵仔煎'
            }],
            siteService: {
                '设备': ['投影仪', 'LED', '话筒', '音响', '舞台', '演讲台', '签到台'],
                '物料': ['会议桌牌', '房间欢迎卡', '会场指示牌', '签到板', '纸笔'],
                '餐饮': ['茶歇', '矿泉水', '自助午餐', '自助晚餐', '围桌午餐', '围桌晚宴']
            }
        }
    },
    computed: {},
    watch: {},
    methods: {

    },
    created() {

    },
    mounted() {

    },
}
</script>
<style lang='scss' scoped>
/deep/ .el-radio {
    margin-right: 0.1rem !important;
}

.container {
    .addBtn {
        border-radius: 0.04rem;
        background-color: rgba(230, 74, 25, 0.1);
        color: rgba(16, 16, 16, 1);
        font-size: 0.12rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: PingFang SC;
    }

    .mianLine {
        margin-bottom: 0.15rem;
        display: flex;
        align-items: center;



        .title {
            color: rgba(16, 16, 16, 1);
            font-size: 0.17rem;
            font-weight: bold;
            font-family: SourceHanSansSC-bold;
        }

        .p_1 {
            color: rgba(16, 16, 16, 1);
            font-size: 0.18rem;
            font-family: SourceHanSansSC-regular;
        }

        .p_2 {
            color: rgba(16, 16, 16, 1);
            font-size: 0.17rem;
            margin-right: 0.15rem;
            font-family: SourceHanSansSC-regular;
        }

        .p_3 {
            margin: 0 0.2rem;
        }



        .addIconSy {
            font-size: 0.3rem;
            color: #DB4E1A;
            font-weight: bold;
            margin-left: 0.2rem;
            margin-right: 0.05rem;
            cursor: pointer;
        }
    }
    .mainDetail {
        .mainDetailLine {
            margin-bottom: 0.2rem;
            width: 100%;
            height: 1px;
            border: 2px dashed #5E6B72;
        }
    }
    .detail {
        margin-bottom: 0.2rem;
        .detailBox {
            padding: 0.1rem;
            width: 100%;
            background-color: rgba(255, 255, 255, 1);
            box-shadow: 1px 1px 3px 2px rgba(0, 0, 0, 0.4);
            display: flex;
            align-items: center;
            justify-content: space-between;

            .detailBoxLine {
                display: flex;
                align-items: center;
                margin-bottom: 0.15rem;

                &:nth-last-child(1) {
                    margin-bottom: 0;
                }
            }

            .detail_p-1 {
                font-size: 0.14rem;
                font-family: SourceHanSansSC-regular;
                margin: 0 0.1rem;
            }

            .detail_p-2 {
                color: #101010;
                font-size: 0.17rem;
                font-family: SourceHanSansSC-regular;
                margin-right: 0.1rem;
            }

            .rightBtnBox {
                width: 1rem;
                display: flex;
                align-items: center;
                flex-direction: column;
                justify-content: space-around;

                .deleteY {
                    height: 0.3rem;
                    width: 0.3rem;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border: 1px solid #BFBFBF;
                    margin-bottom: 0.15rem;

                }
            }
        }
    }

    .serviceLine {
        display: flex;
        align-items: center;
        margin-bottom: 0.15rem;

        &:nth-last-child(1) {
            margin-bottom: 0;
        }

        .serviceTitle {
            color: rgba(219, 78, 26, 0.79);
            font-size: 0.14rem;
            font-family: SourceHanSansSC-regular;
            margin-right: 0.2rem;
        }

        .serviceSelect {
            margin-right: 0.1rem;
            border-radius: 4px;
            background-color: rgba(237, 241, 242, 1);
            color: rgba(16, 16, 16, 1);
            font-size: 0.12rem;
            font-family: PingFang SC;
            padding: 0.05rem 0.1rem;

            &:nth-last-child(1) {
                margin-right: 0;
            }
        }

    }
}
</style>